export default "__VITE_ASSET__CTzC0xiG__"